import React from 'react';
import { bool, object, node } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import VisualHighlight from './VisualHighlight';
import NewDetail from './NewDetail';
import './ProductDetail.css';

const Paragraph = ({ children }) => <p style={{ display: 'inline' }}>{children}</p>;

const ProductDetail = ({ detail, hideDivider, notStylish }) => {
  const defaultRenderer = { paragraph: Paragraph };
  const renderers = detail.visualHighlight ? { ...defaultRenderer, strong: VisualHighlight } : defaultRenderer;
  return (
    <div>
      <div className="box-package__details__detail">
        <span>
          {detail.new && <NewDetail />}
          <ReactMarkdown renderers={renderers} source={detail.text} />
        </span>
        {!notStylish && <span className="imageCertain box-package__details__detail__image" />}
      </div>
      {!hideDivider && !notStylish && <div className="box-package__details__divider" />}
    </div>
  );
};

ProductDetail.propTypes = {
  detail: object.isRequired,
  hideDivider: bool.isRequired,
  notStylish: bool,
};

ProductDetail.defaultProps = {
  notStylish: false,
};

Paragraph.propTypes = {
  children: node.isRequired,
};

export default ProductDetail;
